import {
  DottedMenuIcon,
  FolderNoticePartsIcon,
  SubordinationIcon,
} from "components/page-components/Icons/small"

import React, { useState, useEffect } from "react"

export const PickNoticeParts = ({
  Parts,
  picked_part,
  toggle_parts_modal,
  reset,
}) => {
  const [dropdown_active, set_dropdown_active] = useState(false)

  const toggle_dropdown = (e) => {
    e?.preventDefault()
    set_dropdown_active(!dropdown_active)
  }

  const close_dropdown = (e) => {
    if (e.target.id !== "dropdown-menu-toggle") {
      set_dropdown_active(false)
    }
  }

  useEffect(() => {
    document.body.addEventListener("click", close_dropdown)
    return () => document.body.removeEventListener("click", close_dropdown)
  }, [])

  return (
    <React.Fragment>
      <hr className="is-mitternachtsblau-30 mx-3" />
      <div className="level px-3 has-text-mitternachtsblau is-mobile no-scrollbar">
        <div className="level-left is-clickable">
          {picked_part !== "none" ? (
            <React.Fragment>
              <div className="level-item is-hidden-mobile">
                <SubordinationIcon />
              </div>
              <div
                className="level-item link is-hidden-mobile"
                onClick={reset}
                role="button"
                tabIndex="-1"
                onKeyDown={() => {}}
                aria-label="Open Parts Modal"
              >
                Vergabe
              </div>
              <div className="level-item is-hidden-mobile">/</div>
              <div
                className="level-item link"
                onClick={toggle_parts_modal}
                role="button"
                tabIndex="-1"
                onKeyDown={() => {}}
                aria-label="Open Parts Modal"
                style={{ maxWidth: "85vw" }}
              >
                Los {picked_part?.Number} – {picked_part?.Name}
              </div>
            </React.Fragment>
          ) : (
            <div className="level-item">Kein Los ausgewählt</div>
          )}
          {picked_part === "none" ? (
            <div
              className="level-item link"
              onClick={toggle_parts_modal}
              role="button"
              tabIndex="-1"
              onKeyDown={() => {}}
              aria-label="Open Parts Modal"
            >
              Los auswählen
            </div>
          ) : null}
        </div>
        <div className=" is-right is-hoverable level-right is-clickable">
          <div
            className="level-item"
            onClick={toggle_parts_modal}
            role="button"
            tabIndex="-2"
            onKeyDown={() => {}}
            aria-label="Open Parts Modal"
          >
            <div className="is-hidden-mobile">
              <FolderNoticePartsIcon />
            </div>
            <div className="mr-5 ml-4 is-hidden-mobile">
              {picked_part === "none"
                ? `${Parts.length} Lose`
                : `${Parts.length - 1} weitere${
                    Parts.length > 2 ? "" : "s"
                  } Los${Parts.length > 2 ? "e" : ""}`}
            </div>
          </div>
          <div
            className={`level-item dropdown is-right ${
              dropdown_active ? "is-active" : ""
            }`}
            style={{ width: 24 }}
          >
            <a
              className="dropdown-trigger"
              id="dropdown-menu-toggle"
              href=" #"
              onClick={toggle_dropdown}
              aria-label="menü"
            >
              <DottedMenuIcon />
            </a>
            <div className="dropdown-menu" id="dropdown-menu4" role="menu">
              <div className="dropdown-content" style={{ minWidth: 200 }}>
                <div
                  className="dropdown-item has-text-mitternachtsblau has-text-weight-bold"
                  onClick={toggle_parts_modal}
                  role="button"
                  tabIndex="-3"
                  onKeyDown={() => {}}
                  aria-label="Open Parts Modal"
                >
                  {picked_part === "none" ? "Los auswählen" : "Los wechseln"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
